import React from 'react'
import { Outlet } from 'react-router-dom'

export const PrivateRoutes: React.FC = () => {
  return (
    <>
      <Outlet />
    </>
  )
}
